export default "__VITE_ASSET__C55D$WKN__"